import { createContext, ReactNode, useContext, useMemo, useState } from "react"

interface CalendarNavValue {
  currentDate: Date
  setCurrentDate: (date: Date) => void
}

const CalendarNavContext = createContext<CalendarNavValue | null>(null)

export function CalendarNavProvider({ children }: { children: ReactNode }) {
  const [currentDate, setCurrentDate] = useState<Date>(() => new Date())
  const value = useMemo(() => ({ currentDate, setCurrentDate }), [currentDate])
  return <CalendarNavContext.Provider value={value}>{children}</CalendarNavContext.Provider>
}

/**
 * 캘린더 위젯의 현재 선택 날짜 훅.
 * 헤더의 date nav와 본문 위젯이 같은 날짜 상태를 공유하기 위해 사용.
 */
export function useCalendarNav(): CalendarNavValue {
  const ctx = useContext(CalendarNavContext)
  if (!ctx) {
    // Provider 밖에서 호출되는 경우 fallback — 내부 상태 노출 X, 안전한 no-op
    return {
      currentDate: new Date(),
      setCurrentDate: () => {},
    }
  }
  return ctx
}
